import { AttributesMixin, define } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { PolicyCardBase } from "./policyCardBase";

export interface PolicyCardBound extends AttributesMixin<typeof PolicyCardBound> { }

@define
export class PolicyCardBound extends PolicyCardBase {
    static endpoint = restfulIO('api/v1/ingest/invoices/linking/policies/bound');

    static attributes = {
        ...PolicyCardBase.attributes,
        broker: Object,
        platformBroker: Object,
        lqxPolicyNumber: String,
        policyUid: String,
        carrierPolicyNumber: String,
        lossPayee: String,
        stateId: Number,
        policyTypeId: Number,
        policyCommissionRate: Number,
        buyerCount: Number,
        countryCount: Number,
        createdOn: Date,
        updatedOn: Date,
        platformCode: String,
        isApiEnabled: Boolean,
        liabilityLimit: String, 
        premiumRate: String, 
        policyPremiumTypeName: String,
        coveredAssetTypeId: Number,
        syndicationRuleTypeId: Number,
        indemnity: Number,
        uniqueMarketReference: String
    }
}


